import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error: '',
  error400: false,
  successFlag: false,
  token: '',
  hospitals: [],
  allHospitals: [],
  allHospitalsAdmission: [],
  allActiveHospitals: [],
  totalPages: 0,
  totalRecords: 0,
  hospital: null,
  errorStatus: null,
  hospitalDiagnosisBaseDatas: [],
};
const getters = {
  getApiLoad_40: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_Hospitals(state, hospitals) {
    state.hospitals = hospitals.items;
    state.totalPages = hospitals.totalPages;
    state.totalRecords = hospitals?.totalRecords ?? 0;
  },
  SET_AllHospitals(state, hospitals) {
    state.allHospitals = hospitals;
  },
  SET_AllActiveHospitals(state, hospitals) {
    state.allActiveHospitals = hospitals;
  },
  SET_Hospital(state, hospital) {
    state.hospital = hospital;
  },
  SET_AllHospitalsAdmission(state, hospital) {
    state.allHospitalsAdmission = hospital;
  },
  SET_DiagnosisBaseData(state, hospital) {
    state.hospitalDiagnosisBaseDatas = hospital;
  },
};
const actions = {
  errorHospital({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllHospitals({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Hospitals/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllHospitals', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorHospital', error);
      });
  },
  getAllActiveHospitals({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Hospitals/Active', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllActiveHospitals', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorHospital', error);
      });
  },
  getHospitalsWithPagination(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, title, cityId },
  ) {
    var url = '/Hospitals/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (title) {
      url += '&Title=' + title;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_Hospitals', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorHospital', error);
      });
  },
  addHospital({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Hospitals', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorHospital', error);
      });
  },
  getHospital({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Hospitals/ById?hospitalId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Hospital', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorHospital', error);
      });
  },
  editHospital({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Hospitals/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorHospital', error);
      });
  },
  deleteHospital({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Hospitals/Remove?hospitalId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorHospital', error);
      });
  },
  getAllHospitalsAdMission({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Hospitals/WithAdmissionCount', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllHospitalsAdmission', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorHospital', error);
      });
  },
  hospitalDiagnosisBaseDatas({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Hospitals/Diagnoses?hospitalId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_DiagnosisBaseData', response.data);
      })
      .catch((error) => {
        dispatch('errorHospital', error);
      });
  },
  editHospitalDiagnosisBaseData({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Hospitals/Diagnoses', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorHospital', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
